import API from '../api';

export const getGenders = ({
  params: { page, uuid, page_size } = {},
  signal,
} = {}) => {
  return new Promise((resolve, reject) => {
    try {
      API.get(`/auth/genders/`, { signal })
        .then((res) => {
          resolve(res?.data);
        })
        .catch((err) => {
          reject('axios error', err);
        });
    } catch (error) {
      reject('system error', error);
    }
  });
};

export const getUser = (uuid) => {
  return new Promise((resolve, reject) => {
    try {
      API.get(`/auth/users/${uuid}`)
        .then((res) => {
          resolve(res?.data);
        })
        .catch((err) => {
          reject('axios error', err);
        });
    } catch (error) {
      reject('system error', error);
    }
  });
};

export const uploadAvatar = (file) => {
  const data = new FormData();
  data.append('avatar', file);
  return API.put('/auth/users/avatar/', data, {
    headers: { 'Content-Type': 'multipart/form-data' },
  }).then((response) => response.data);
};

export const deleteAvatar = () =>
  API.delete('/auth/users/avatar/').then((response) => response.data);

export const getCountries = ({ params: { page_size } = {}, signal } = {}) => {
  return new Promise((resolve, reject) => {
    try {
      API.get(`/auth/countries/`, { params: { page_size }, signal })
        .then((res) => {
          resolve(res?.data);
        })
        .catch((err) => {
          reject('axios error', err);
        });
    } catch (error) {
      reject('system error', error);
    }
  });
};

export const postUserDocument = (data) => {
  return new Promise((resolve, reject) => {
    try {
      API.post(`/auth/user_documents/`, data, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      })
        .then((res) => {
          resolve(res?.data);
        })
        .catch((err) => {
          reject('axios error', err);
        });
    } catch (error) {
      reject('system error', error);
    }
  });
};

export const patchUserDocument = (uuid, data) => {
  return new Promise((resolve, reject) => {
    try {
      API.patch(`/auth/user_documents/${uuid}/`, data, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      })
        .then((res) => {
          resolve(res?.data);
        })
        .catch((err) => {
          reject('axios error', err);
        });
    } catch (error) {
      reject('system error', error);
    }
  });
};

export const getUserDocumentTypes = () => {
  return new Promise((resolve, reject) => {
    try {
      API.get(`/auth/user_document_types`)
        .then((res) => {
          resolve(res?.data);
        })
        .catch((err) => {
          reject('axios error', err);
        });
    } catch (error) {
      reject('system error', error);
    }
  });
};
